module.exports = __webpack_public_path__ + "static/media/profitloss.2920662e.svg";